import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { Separator } from '~/components/ui'
import { MapCityFilter, MapCountyFilter, MapZipCodeFilter } from '.'

type MapLocationFilterProps = {
  cities: string[]
  counties: string[]
  zipCodes: string[]
  updateFilter: (key: string, value: any) => void
}

async function getLocationFilters() {
  const response = await fetch('/api/filters', {
    method: 'POST',
  })
  const result = await response.json()
  if (!result.success) {
    console.error('Error getting location filters', result.error)
    throw new Error(`There was a problem fetching results: ${result.error}`)
  }
  return result
}

export default function MapLocationFilter({
  cities,
  counties,
  zipCodes,
  updateFilter,
}: MapLocationFilterProps) {
  const filtersQuery = useQuery({
    queryKey: ['location-filters', 'disable-cache'],
    queryFn: () => getLocationFilters(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })

  const cityValues = useMemo(
    () => filtersQuery.data?.cities || [],
    [filtersQuery.data]
  )

  const countyValues = useMemo(
    () => filtersQuery.data?.counties || [],
    [filtersQuery.data]
  )

  const zipCodeValues = useMemo(
    () => filtersQuery.data?.zipCodes || [],
    [filtersQuery.data]
  )

  if (!cityValues.length && !countyValues.length && !zipCodeValues.length) {
    return null
  }

  return (
    <div className="space-y-2">
      <Separator />
      <p className="font-semibold">Location</p>
      {cityValues.length > 0 && (
        <MapCityFilter
          cityValues={cityValues}
          filterCity={cities}
          updateFilter={updateFilter}
        />
      )}
      {countyValues.length > 0 && (
        <MapCountyFilter
          countyValues={countyValues}
          filterCounty={counties}
          updateFilter={updateFilter}
        />
      )}
      {zipCodeValues.length > 0 && (
        <MapZipCodeFilter
          zipCodeValues={zipCodeValues}
          filterZipCode={zipCodes}
          updateFilter={updateFilter}
        />
      )}
    </div>
  )
}
